export enum ClassEnums {
  Button = "Button",
  FormField = "FormField",
  FileUploader = "FileUploader",
  Input = "Input",
  Tooltip = "Tooltip",
  IconButton = "IconButton"
}
